// APP_* переменные из .env подставляются в index.html как window.__APP_CONFIG__:
// в проде - сервером при старте (src/server/index.ts), в dev - webpack'ом
// (webpack.config.js). Так адрес API и ключ меняются правкой .env на сервере
// и перезапуском, без пересборки.
const env = window.__APP_CONFIG__ ?? {};

export const config = {
  apiBaseUrl: env.APP_API_BASE_URL ?? 'http://localhost:9005',
  // Бэкенд с этой сессии требует X-Api-Key на все запросы (см. gar/src/app.ts).
  // Ключ попадает в публичный HTML - это не секрет в строгом смысле, просто
  // ограничивает трафик конкретно от этого сайта лимитом ключа, не защита от
  // того, кто его вытащит из devtools.
  apiKey: env.APP_API_KEY ?? '',
  tileStyleUrl: env.APP_TILE_STYLE_URL ?? '/styles/light.json',
  // тёмная тема; генерируется из light.json (scripts/make-dark-style.mjs)
  darkStyleUrl: env.APP_DARK_STYLE_URL ?? '/styles/dark.json',
  initialView: {
    lat: Number(env.APP_MAP_CENTER_LAT ?? 55.751244),
    lng: Number(env.APP_MAP_CENTER_LNG ?? 37.618423),
    zoom: Number(env.APP_MAP_ZOOM ?? 11),
  },
} as const;
